module.exports = __webpack_public_path__ + "img/interview.e13e43e2.svg";